"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ability_HiveMother_OnTickEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const EffectType_1 = require("../../core/effects/EffectType");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
let Ability_HiveMother_OnTickEventHandlerScript = class Ability_HiveMother_OnTickEventHandlerScript {
    run(sequence, container, handler, event) {
        const withSwarm = container.selectLivingTargets(event.subject, Target_1.Target.AllEnemies);
        if ((0, Random_1.randomPercent)() <= 75 || withSwarm.some(targetId => container.hasEffectOfType(targetId, EffectType_1.EffectType.Swarmed))) {
            // 25% chance to swarm a party member when no party members are swarmed.
            return;
        }
        const canSwarm = container.selectLivingTargets(event.subject, Target_1.Target.AllEnemies)
            .filter(targetId => !container.hasEffectOfType(targetId, EffectType_1.EffectType.Swarmed));
        if (canSwarm.length === 0) {
            return;
        }
        const targetId = (0, Random_1.randomElement)(canSwarm);
        container.applyDebuff({
            sequence,
            attackerId: event.subject,
            targetId,
            duration: Duration_1.Duration.Permanent,
            effect: new core_1.SwarmedEffectArgs()
        });
    }
};
Ability_HiveMother_OnTickEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Ability_HiveMother_OnTick")
], Ability_HiveMother_OnTickEventHandlerScript);
exports.Ability_HiveMother_OnTickEventHandlerScript = Ability_HiveMother_OnTickEventHandlerScript;
